<!--na ginei epilogh poias ME tha ginei o diaxeiristis kai tha deixnei ola ta stelexh. Tha doume to pws. -->

<template>
    <main class="login-form">
        <div class="cotainer">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <form>
                        <div class="card-header">{{title}}</div>
                        <div class="card" id="search">
                            <div>
                                <label for="search" class="col-md-0 col-form-label text-md-right">Αναζήτηση με βάση τον
                                    Α.Μ.</label><br>
                                <input type="text" id="monimosasm" name="text" required><br>
                                <br>
                            </div>
                            <div class="col-md-12">
                                <button v-on:click.prevent="onSearch" class="btn btn-primary">
                                    Αναζήτηση
                                </button>
                            
                            </div>
                            <br>
                        </div>
                        <br>
                        <b-container id="stoixeiame">
                            <b-row>
                                <b-col sm="4" offset-sm="4">
                                    <b-form-group label="Επώνυμο" label-align="left" label-cols="4">
                                        <b-form-input v-model="epwnymo" trim disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4" offset-sm="4">
                                    <b-form-group label="Όνομα" label-align="left" label-cols="4">
                                        <b-form-input v-model="onoma" trim disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4" offset-sm="4">
                                    <b-form-group label="Α.Μ." label-align="left" label-cols="4">
                                        <b-form-input v-model="am" disabled trim></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4" offset-sm="4">
                                    <b-form-group label="Υπ. Μονάδα:" label-align="left" label-cols="4">
                                        <b-form-input v-model="yphrMonadaLek" disabled trim></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="isMe || isSxhmatismos">
                                <b-col sm="4" offset-sm="4">
                                    <b-form-group label="Παρακολ. Μονάδα: " label-align="left" label-cols="4">
                                        <b-form-select v-model="parakolMonada" :options="me_items"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4" offset-sm="4">
                                    <b-form-group label="E-mail:" label-align="left" label-cols="4">
                                        <b-form-input v-model="email" trim></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="show_error" class="alert alert-danger alert-dismissible fade show col-md-8"
                                   role="alert"
                                   style="margin-left: 20%;">
                                {{ errorMessage }}
                            </b-row>
                            <b-row>
                                <b-col sm="4" offset-sm="4">
                                    <br>
                                    <button v-on:click.prevent="Submitme" class="btn btn-primary">
                                        Καταχώρηση
                                    </button>
                                </b-col>
                            </b-row>
                        </b-container>
                        <div class=col-md-12>
                            <div v-if="show_ok" class="alert alert-success alert-dismissible fade show col-md-8"
                                 role="alert"
                                 style="margin-left: 20%;">
                                Ο Νέος διαχειριστής καταχωρήθηκε με επιτυχία!
                                Επιστροφή στην
                                <router-link to="/home">Aρχική</router-link>
                                ή <a href="#" v-on:click.prevent="refreshPage">δημιουργία νέου</a>
                            </div>
                        </div>
                        <div class=col-md-12>
                            <div v-if="flag_invalid_am" class="alert alert-danger alert-dismissible fade show col-md-8"
                                 role="alert"
                                 style="margin-left: 20%;">
                                Παρακαλώ δώστε ένα έγκυρο Α.Μ. .
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import {HTTP} from '../main.js'
import {Structs} from "../structs.js";

export default {
    name: "RegisterAdmin",
    props:  {
        isMe: Boolean,
        title: String,
        isSxhmatismos: Boolean
    },

    mounted() {  
        $('#stoixeiame').hide();
    },
    methods: {
        refreshPage: function () {
            this.$router.go();
        },
        onSearch() {
            // Post data
            var input = $("input[name='text']").val();

            if (input === '') {
                this.flag_invalid_am = true;
            } else {
                this.$store.dispatch('loading')
                HTTP.post("/admin/fetch-monimos-by-kwd", {"strkProsKwd": input})
                    .then((response) => {
                        $('#search').hide();
                        $('#stoixeiame').show();
                        let resp = response.data

                        let admin = resp.responseData;
                        this.onoma = admin.onoma;
                        this.yphrMonadaLek = admin.yphrMonadaLek;
                        this.epwnymo = admin.epwnymo;
                        this.am = admin.strkProsKwd;

                        this.flag_invalid_am = false;
                    })
                    .catch((e) => {
                        this.flag_invalid_am = true;
                        console.error(e);
                    })
                    .finally(() => this.$store.dispatch('stop_loading'));
            }
        },

        Submitme() {
            this.show_error = false;
            if (this.email === '') {
                this.errorMessage = 'Παρακαλώ εισάγετε ένα έγκυρο E-mail.'
                this.show_error = true
                return
            }
            if (this.isMe && this.parakolMonada.efEaPinakaE === '') {
                this.errorMessage = 'Παρακαλώ εισάγετε μία έγκυρη μονάδα.'
                this.show_error = true
                return
            }
            
            let url;
            let admin = Structs.Admin();

            if(this.isSxhmatismos) {
                         
                url = "/manager/sxhmatismos";
                
                admin.parakolMonada = {
                    efEaPinakaE: this.parakolMonada.monaKwd,
                    monaLek: this.parakolMonada.monaLek,
                    parentMonaKwd: null,
                    sximatismoiKwd: null,
                    visibleToDiaxeiristi: true
                };
            }

            admin.strkProsKwd = this.am
            admin.email = this.email

            if (this.isMe) {
                admin.parakolMonada = this.parakolMonada
                url = "/manager";
            } else if(!this.isSxhmatismos) {
                url = "/admin";
            }

            this.$store.dispatch("loading")
            HTTP.post(url, admin)
                .then((response) => {
                    var resp = response.data;
                    $('#stoixeiame').hide();
                    this.show_ok = true;
                    this.show_error = false;
                }).catch((e) => {
                console.error(e);
                if (e.response.data.errorMessage) {
                    this.errorMessage = e.response.data.errorMessage
                } else {
                    this.errorMessage = 'Υπήρξε κάποιο πρόβλημα κατά τη δημιουργία του Διαχειριστή.'
                }
                this.show_ok = false;
                this.show_error = true
            }).finally(() => this.$store.dispatch("stop_loading"));
        }
    },

    data: function () {
        return {
            me_items: [],
            parakolMonada: Structs.AdiavMeeMona(),

            onoma: "",
            epwnymo: "",
            am: "",
            yphrMonadaLek: "",
            email: "",

            show_ok: false,
            show_error: false,
            flag_invalid_am: false,
            token: '',
            errorMessage: '',
        }
    }
}
</script>

<style scoped>

</style>